import type { RequestOptions } from '@/libs/api/types';
import { submitContact, type SubmitContactRequest } from '@/services/submit-contact';
import { useMutation } from '@tanstack/react-query';

/**
 * Sends a Contact Us request via POST `/api/v1/contact`. Backend errors surface through
 * the shared server-error popup; pass `{ skipServerErrorAlert: true }` to handle them at
 * the call site instead.
 */
export function useSubmitContactMutation(options?: RequestOptions) {
  return useMutation({
    mutationFn: (body: SubmitContactRequest) => submitContact(body, options),
  });
}

export default useSubmitContactMutation;
